var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badges/User profile/48px/Fail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1610"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1240",
    cx: 32.75,
    cy: 32.6641,
    r: 32,
    fill: "#C60F13"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 831952",
    x: 30.75,
    y: 47.6641,
    width: 4,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 831953",
    x: 30.75,
    y: 12.6641,
    width: 4,
    height: 30,
    rx: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/Fail.baefcb32f0d2b65db7cf6889489720f1.svg";
export { ForwardRef as ReactComponent };